<template>
    <footer id="main_footer" :class="{ 'mobile' : mobile}">
        <table>
            <tr>
                <td>
                    <small>
                        Åsas Bemanning AB<br />
                        Bergslagsgatan 3, 776 30 Hedemora<br />
                        0225 - 25 44 00
                    </small>
                    <div class="fb-like" data-href="https://www.facebook.com/asasbemanning/" data-width="" data-layout="button_count" data-action="like" data-size="small" data-show-faces="true" data-share="true"></div>
                </td>
                <td align="right" width="250px" v-if="!mobile">
                    <img src="../assets/asas_logo.svg" width="200px"/>
                </td>
            </tr>
        </table>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data: function () {
        return {
            mobile: window.mobilecheck()
        };
    }
}
</script>

<style scoped>
    @import url("../assets/css/footer.module.css");
</style>
